<template>
  <v-card
    class="product-slider-card"
    rounded="sm"
    elevation="0"
    flat
    :to="link"
    :style="`backgroundColor : ${backgroundColor}`"
    @click.prevent="handleLink"
  >
    <v-img
      :src="img"
      alt="Immagine categoria"
      class="product-slider-card-image"
    />
    <v-card-text v-if="text" v-html="text"> </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions v-if="link" class="w-100 pa-0">
      <v-btn class="w-100" block :to="link" color="primary lighten-1" large
        >{{ linkLabel }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss">
.product-slider-card {
  position: relative;
  .v-card__actions {
    position: absolute;
    left: 0;
    bottom: -4px;
  }
}
</style>
<script>
export default {
  name: "ProductSliderCard",
  props: {
    img: { type: String, required: true },
    text: { type: String, required: false },
    link: { type: [String, Object], required: false },
    linkLabel: { type: String, required: false, default: "Mostra tutti" },
    backgroundColor: { type: String, required: false, default: "white" }
  }
};
</script>
